import { render } from "./logoff.vue?vue&type=template&id=3ca20c2d"
import script from "./logoff.vue?vue&type=script&lang=js"
export * from "./logoff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__